(function (Drupal) {

  Drupal.behaviors.customSelect = {
    attach(context) {
      if (window.multipleSelect !== undefined) {
        const selects = document.querySelectorAll('select.custom-select[multiple]');
        const facets = context.querySelectorAll('ul[data-drupal-facet-id="tags"] li.facet-item');

        selects.forEach((select) => {
          multipleSelect(select, {
            selectAll: false,
            width: '100%',
            filter: true,
            displayTitle: true,
            renderOptionLabelAsHtml: true,
            onAfterCreate: () => updatePlaceholder(select),
            onCheckAll: () => updatePlaceholder(select),
            onUncheckAll: () => updatePlaceholder(select),
            onOptgroupClick: () => updatePlaceholder(select),
            onClick: (view) => {
              const value = view.value.toLowerCase();
              clickToLinks(facets, value);
              updatePlaceholder(select);
            },
            onClose: () => {
              callback_onSelect(select);
            },
          });
        });

        multipleSelect('select.custom-select:not([multiple])', {
          selectAll: false,
          width: '100%',
          filter: true,
          displayTitle: true,
          renderOptionLabelAsHtml: true,
        });

        context.querySelectorAll('select.form-select + div').forEach(element => {
          element.classList.remove('form-select');
        });
      }

      function callback_onSelect(select) {
        let collection = select.selectedOptions;
        const values = [...collection].map((option) => {
          return option.label;
        });
      }

      function clickToLinks(facets, value) {
        facets.forEach((facet) => {
          if (facet.querySelector('label span').innerText.toLowerCase() === value) {
            facet.querySelector('a').click();
          }
        });
      }

      function updatePlaceholder(select) {
        const placeholder = select.getAttribute('data-placeholder');
        const selectedOptions = select.selectedOptions;
        const selectedCount = selectedOptions.length;

        const placeholderSpan = select.nextElementSibling.querySelector('.ms-choice span');
        if (selectedCount > 0) {
          placeholderSpan.innerHTML = `${placeholder} <span class="count">${selectedCount}</span>`;
        }
        else {
          placeholderSpan.textContent = placeholder;
        }
      }
    },
  };
})(Drupal);
